<!--
    描述：业务字段列表
    时间：2020-05-18
    Created by yefan
-->
<template>
    <div class="w-table-layout w-table-page">
        <transition name="fade" mode="out-in">
            <!-- 列表 -->
            <div class="list-wrap w-table-content" ref="tableContent" key="list">
                <el-table :data="tableObj.tableData" row-key="id" v-loading="tableObj.loading" ref="tableObj"
                          default-expand-all :height="tableObj.tableH" border highlight-current-row>
                    <el-table-column type="index" lable="序号" align="center" width="100"></el-table-column>
                    <el-table-column prop="title" label="业务字段名称" align="center" show-overflow-tooltip
                                     min-width="150"></el-table-column>
                    <el-table-column prop="businessTypeName" label="业务模板" align="center" show-overflow-tooltip
                                     min-width="150"></el-table-column>
                    <el-table-column prop="formTypeName" label="字段类型" align="center" show-overflow-tooltip
                                     min-width="100"></el-table-column>
                    <el-table-column prop="remark" label="业务备注" header-align="center" show-overflow-tooltip
                                     min-width="180"></el-table-column>
                    <el-table-column label="操作" align="center" show-overflow-tooltip width="120">
                        <template slot-scope="scope">
                            <el-button size="mini" icon="el-icon-edit"
                                       title="编辑" type="text"
                                       @click="doClick(scope.row,'edit')"></el-button>
                            <el-button size="mini" icon="el-icon-search"
                                       title="查看" type="text"
                                       @click="doClick(scope.row,'view')"></el-button>
                            <el-button size="mini" icon="el-icon-delete"
                                       title="删除" type="text"
                                       @click="doClick(scope.row,'delete')"></el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </transition>

        <!-- 底部分页 -->
        <div class="w-table-footer">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                           :current-page="tableObj.currentPage" :page-sizes="tableObj.pageList"
                           :page-size="tableObj.pageSize" layout="total, sizes, prev, pager, next, jumper"
                           :total="tableObj.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import {getPublicFields} from '@/api/modules/analysis.js'
    import {exportExcel} from '@/utils/tools'

    export default {
        data() {
            return {
                searchObj: {
                    title: '',
                    formType: ''
                },
                tableObj: {
                    loading: false,
                    tableH: 400,
                    tableData: [],
                    currentPage: 1,
                    pageSize: 10,
                    total: 0,
                    pageList: [10, 20, 50, 100] // 显示条数数组
                }
            }
        },
        created() {
            this.getTablePageList()
        },
        mounted() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.tableObj.tableH = this.$refs.tableContent.offsetHeight
                }, 100)
            })
        },
        // 进入缓存页面触发
        activated() {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.tableObj.tableH = this.$refs.tableContent.offsetHeight
                }, 100)
            })
        },
        methods: {
            //编辑按钮事件
            doClick(row, type) {
                this.$emit('doClick', type, row)
            },

            searchPageList(obj) {
                this.searchObj = obj;
                this.tableObj.currentPage = 1;
                this.getTablePageList()
            },

            //加载列表数据
            getTablePageList() {
                let that = this;
                let param = {};
                param.current = this.tableObj.currentPage;
                param.size = this.tableObj.pageSize;
                param.title = this.searchObj.title;
                param.formType = this.searchObj.formType;
                getPublicFields(param).then(res => {
                    if (res.code == 0) {
                        that.tableObj.tableData = res.data.records
                        this.tableObj.total = parseInt(res.data.total)
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            },

            // 切换显示条数
            handleSizeChange(val) {
                this.tableObj.pageSize = val;
                this.getTablePageList()
            },

            // 切换当前页码
            handleCurrentChange(cur) {
                this.tableObj.currentPage = cur;
                this.getTablePageList()
            },

            //导出Excel按钮事件
            exportExcel() {
                exportExcel('analysisPublicField/exportPublicFields', {}, '公共业务字段')
            },
        },

        computed: {
            ...mapState('app', {clientSize: state => state.clientSize}),
            ...mapState('menu', {
                roleBtns: state => state.roleBtns
            })
        },

        watch: {
            clientSize(val) {
                this.tableObj.tableH = this.$refs.tableContent.offsetHeight
            }
        },
    }
</script>

<style scoped>

</style>